<script setup lang="ts">
import { defineProps } from 'vue';
import SettingsIcon from '@/dashboard/vue/components/icons/SettingsIcon.vue';
import LogoutIcon from '@/dashboard/vue/components/icons/LogoutIcon.vue';
import ArchiveIcon from '@/dashboard/vue/components/icons/ArchiveIcon.vue';
import DeleteIcon from '@/dashboard/vue/components/icons/DeleteIcon.vue';
import ContextMenuButton from '@/dashboard/vue/components/common/ContextMenu/ContextMenuButton.vue';
import { useDirectoryContextMenu } from '@/dashboard/vue/components/contexts/DirectoryContextMenu/useDirectoryContextMenu';

const props = defineProps<{
  id: number;
}>();

const { menuItems } = useDirectoryContextMenu(props.id);
</script>

<template>
  <div class="flex w-full flex-col gap-[2px] p-[6px]">
    <template v-for="item in menuItems" :key="item.label">
      <ContextMenuButton v-if="item.canRender" :need-dark="true" :action="item.action" class="w-full">
        <div class="flex items-center gap-[10px] whitespace-nowrap">
          <LogoutIcon v-if="item.icon === 'LogoutIcon'" :class="['h-s w-s', item.iconClass]" />
          <ArchiveIcon v-else-if="item.icon === 'ArchiveIcon'" :class="['h-s w-s', item.iconClass]" />
          <SettingsIcon v-else-if="item.icon === 'SettingsIcon'" :class="['h-s w-s', item.iconClass]" />
          <DeleteIcon v-else-if="item.icon === 'DeleteIcon'" :class="['h-s w-s', item.iconClass]" />
          <span class="text-caption-s" :class="item.labelClass">{{ item.label }}</span>
        </div>
      </ContextMenuButton>
    </template>
  </div>
</template>
